
import React from 'react';

import Combobox from '@usas/ui-web/components/comboboxes/Combobox'

import global from '@usas/ui-web/components/GlobalStyle.module.css';

const LargeGridRow = ({ i, formState, options, onValueTextPairChanged }) => (
  <tr style={{ height: "80px" }}>
    <td style={{ width: "5%" }}>{i}</td>
    <td style={{ width: "20%" }}>
      <Combobox
        name={`orgUnitId${i}`}
        valueToMatch={formState[`orgUnitName${i}`] || ''}
        items={options}
        onChange={(newValue, newValueLabel) => { onValueTextPairChanged(newValue, `orgUnitId${i}`, newValueLabel, `orgUnitName${i}`); }} />
    </td>
    <td style={{ width: "60%" }}></td>
  </tr>
);

const GridTBody = ({ numberOfLanes, startingLaneNumber, formState, options, onValueTextPairChanged }) => {
  const rows = [];

  if (startingLaneNumber > 1) {
    for (let i = numberOfLanes; i >= 1; i--) {
      rows.push(<LargeGridRow key={i} i={i} formState={formState} options={options} onValueTextPairChanged={onValueTextPairChanged} />)
    }
  } else {
    for (let i = 1; i <= numberOfLanes; i++) {
      rows.push(<LargeGridRow key={i} i={i} formState={formState} options={options} onValueTextPairChanged={onValueTextPairChanged} />)
    }
  }

  return <tbody>{rows}</tbody>;
};

const LaneSheetHeatRelayTeamFormGridLarge = ({ numberOfLanes, startingLaneNumber, formState, options, onValueTextPairChanged }) => (
  <table className={[global.UsasTable, 'visible-md visible-lg'].join(' ')}>
    <thead>
      <tr>
        <th>Lane #</th>
        <th>Relay Team</th>
        <th></th>
      </tr>
    </thead>
    <GridTBody numberOfLanes={numberOfLanes} startingLaneNumber={startingLaneNumber} formState={formState} options={options} onValueTextPairChanged={onValueTextPairChanged} />
  </table>
);

export default LaneSheetHeatRelayTeamFormGridLarge